import { render } from "./EventHighlights.vue?vue&type=template&id=3bbbc6fa&scoped=true"
import script from "./EventHighlights.vue?vue&type=script&lang=js"
export * from "./EventHighlights.vue?vue&type=script&lang=js"

import "./EventHighlights.vue?vue&type=style&index=0&id=3bbbc6fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbbc6fa"]])

export default __exports__